@if (!!questions) {
  <div class="replace-vehicle main">
    <div class="row">
      <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
        <h2
          dsContent
          [contentPath]="'policy.newVehicleUnderwritingQuestionsHeader'"
          class="font-weight-bold"
        ></h2>
        <form [formGroup]="underWritingQuestionsForm" (ngSubmit)="answersSubmit()">
          <div>
            <div class="row pad-bottom-10">
              <div>
                @if (!isPartner) {
                  <ds-radio-group
                    data-cy="vehicleUnderwritingQuestionsCheckbox"
                    class="radio-group-container"
                    control="option"
                    selectedAnswer=""
                    [parentFormGroup]="underWritingQuestionsForm"
                    [options]="questions"
                  >
                  </ds-radio-group>
                }
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
        <call-to-action
          [displayBackButton]="true"
          [primaryButtonName]="(isPartner$ | async) ? 'Next Step' : 'Continue'"
          (primaryEvent)="answersSubmit()"
          (backEvent)="goBackOneStep()"
          tertiaryButtonName="Cancel"
          [disablePrimaryButton]="underWritingQuestionsForm?.invalid"
          (tertiaryEvent)="cancel()"
        >
        </call-to-action>
      </div>
    </div>
  </div>
}

<ds-exit-flow-modal
  [exitFlowModalId]="exitFlowModalId"
  [isPartner]="isPartner$ | async"
  (exit)="navigateToOverview()"
  (cancelModal)="stay()"
  (notifyAgent)="sendToAgent()"
></ds-exit-flow-modal>
